export default __webpack_public_path__ + "files/media/md-private.5be4e3dd.jpg";